<template>
  <v-card outlined>
    <v-card-title>
      {{ formTitle }}
      <v-spacer />
      <v-btn
        color="white"
        depressed
        small
        fab
        @click="
          editItem ? cancelEdit() : deleteItem ? cancelDel() : cancelNew()
        "
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-list>
          <v-list-item>
            <v-text-field
              v-model="items.name"
              label="Strategy Name"
              required
              :rules="rules.name"
              counter="20"
              clearable
              :disabled="deleteItem ? true : false"
            ></v-text-field>
          </v-list-item>

          <v-list-group v-for="[cmd, paras] in formData" :key="cmd" value="true" no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="cmd.toUpperCase()"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="[k, v] in Object.entries(paras)" :key="k" dense>
              <v-list-item-content>
                <v-slider
                  v-if="v.unit === 'balance' || v.unit === 'euqity' || v.unit === 'profit'"
                  v-model="v.value"
                  thumb-label
                  min="0"
                  max="100"
                  step="1"
                  :rules="rules.percentage"
                  :disabled="deleteItem ? true : false"
                  class="width: 10px"
                >
                  <template v-slot:prepend>
                    <v-text-field
                      v-model="v.value"
                      :label="v.name"
                      :prefix="k + ' @ '"
                      :suffix="'% '+ v.unit"
                      class="mt-0 pt-0"
                      type="number"
                      style="width: 150px"
                      :disabled="deleteItem ? true : false"
                    ></v-text-field>
                  </template>
                </v-slider>
                <v-text-field
                  v-else
                  v-model="v.value"
                  :label="v.name"
                  :prefix="k + ' @ '"
                  :suffix="v.unit"
                  class="width: 100px"
                  type="number"
                  clearable
                  :disabled="deleteItem ? true : false"
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-action>
                <v-checkbox
                  v-model="v.overwriteIfNone"
                  :disabled="deleteItem ? true : false"
                  label="Overwrite If None"
                  dense
                  class="mx-3"
                  style="text-right"
                ></v-checkbox>
                <v-checkbox
                  v-model="v.overwriteAlways"
                  :disabled="deleteItem ? true : false"
                  label="Always Overwrite"
                  dense
                  class="mx-3"
                  style="text-right"
                ></v-checkbox>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
        <v-checkbox v-model="agree" :rules="rules.required" label="Are you sure?" required></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-if="editItem">
      <v-btn outlined color="primary" text block :disabled="!valid" @click="onEdit">UPDATE</v-btn>
    </v-card-actions>
    <v-card-actions v-else-if="deleteItem">
      <v-btn
        color="primary"
        text
        outlined
        block
        :disabled="deleteItem.id == 'default' || !valid"
        @click="onDelete"
      >DELETE</v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-btn outlined color="primary" text block :disabled="!valid" @click="onCreate">CREATE</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
// import * as strategyData from "@/components/strategies/strategy.js";
import { STRATEGY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "StrategyCRUD",
  props: {
    editItem: {
      type: Object,
      default: null
    },
    deleteItem: {
      type: Object,
      default: null
    },
    newItem: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    valid: false,
    agree: false,
    rules: {
      percentage: [v => (!!v && v >= 0 && v <= 100) || "Value from 0 to 100"],
      required: [v => !!v || "You must agree to continue!"],
      name: [
        v => (v && v.length <= 20) || "Name must be less than 20 characters"
      ]
    }
    // enableScopes: ["buy", "sell", "stoploss", "trailing", "close"]
  }),
  computed: {
    ...mapGetters(["currentUser", "strategies"]),
    formTitle() {
      if (this.editItem) {
        return "Update Strategy";
      } else if (this.deleteItem) {
        return "Delete Strategy";
      } else {
        return "Create Strategy";
      }
    },
    items() {
      return this.editItem || this.deleteItem || this.newItem;
    },
    formData() {
      let a = Object.entries(this.items);
      return a.filter(v => {
        return (
          v[0] != "id" &&
          v[0] != "userId" &&
          v[0] != "timestamp" &&
          v[0] != "name"
        );
      });
    }
  },
  methods: {
    onCreate() {
      this.items.userId = this.currentUser.uid;
      this.$store.dispatch(STRATEGY.CREATE, this.items).then(this.cancelNew());
    },
    onEdit() {
      this.$store.dispatch(STRATEGY.EDIT, this.items).then(() => {
        this.cancelEdit();
      });
    },
    onDelete() {
      this.$store.dispatch(STRATEGY.DEL, this.items).then(() => {
        this.cancelDel();
      });
    },
    goTo(path) {
      this.$router.push(path);
    },
    cancelDel() {
      this.$emit("deleted", null);
    },
    cancelEdit() {
      this.$emit("edited", null);
    },
    cancelNew() {
      this.$emit("closed", false);
    }
  }
};
</script>
